module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-header"
  }, [_c('span', {
    staticClass: "kt-subheader__title"
  }, [_vm._v(_vm._s(_vm.nameSection) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "kt-subheader__breadcrumbs"
  }, [_c('router-link', {
    staticClass: "kt-subheader__breadcrumbs-home",
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-home"
  })]), _vm._v(" "), _vm._l((_vm.listRoutes), function(route) {
    return _c('div', {
      staticClass: "bread-new"
    }, [_c('span', {
      staticClass: "kt-subheader__breadcrumbs-separator"
    }), _vm._v(" "), (!route.idRoute) ? _c('router-link', {
      staticClass: "kt-subheader__breadcrumbs-link",
      attrs: {
        "to": {
          name: route.nameRoute
        }
      }
    }, [_vm._v(_vm._s(route.titleRoute))]) : _vm._e(), _vm._v(" "), (route.idRoute) ? _c('router-link', {
      staticClass: "kt-subheader__breadcrumbs-link",
      attrs: {
        "to": {
          name: route.nameRoute,
          params: {
            id: route.idRoute
          }
        }
      }
    }, [_vm._v(_vm._s(route.titleRoute))]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.activeRoute) ? _c('span', {
    staticClass: "bread-new"
  }, [_c('span', {
    staticClass: "kt-subheader__breadcrumbs-separator"
  }), _vm._v(" "), _c('span', {
    staticClass: "kt-subheader__breadcrumbs-link route-none"
  }, [_vm._v(_vm._s(_vm.activeRoute))])]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b0b3d66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prefab/structures/breadcrumb.vue
// module id = 1884
// module chunks = 1